import React from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { MainRoutes } from "../../../../shared/models";

interface Props {
  data: {
    skill_id?: string;
    skill_name: string;
    completed_count?: number;
    total_count?: number;
    summary?: string;
  };
}

export const SkillProgressWidget: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const percentage = data.total_count && data.total_count > 0 
    ? Math.round((data.completed_count || 0) / data.total_count * 100) 
    : 0;

  const handleViewSkill = () => {
    if (data.skill_id) {
      navigate(MainRoutes.TraitDetails.replace(":traitId", data.skill_id));
    }
  };

  return (
    <div className="bg-card rounded-xl border-2 border-border/50 p-4 mt-2 shadow-sm">
      <div className="flex justify-between items-start mb-3">
        <h4 className="font-semibold text-foreground">{data.skill_name}</h4>
        {data.skill_id && (
          <button
            onClick={handleViewSkill}
            className="text-xs text-primary hover:text-primary/80 underline"
          >
            {t('widgets.viewSkill')}
          </button>
        )}
      </div>

      {data.total_count !== undefined && (
        <div className="bg-muted/50 rounded-xl p-3 border border-border/30">
          <div className="flex justify-between text-sm text-muted-foreground mb-2">
            <span>{t('widgets.sessionsProgress', { completed: data.completed_count || 0, total: data.total_count })}</span>
            <span className="font-medium text-foreground">{t('widgets.percentage', { percentage })}</span>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div
              className="bg-primary h-2 rounded-full transition-all duration-300"
              style={{ width: `${percentage}%` }}
            />
          </div>
        </div>
      )}

      {data.summary && (
        <p className="text-sm text-muted-foreground mt-3">{data.summary}</p>
      )}
    </div>
  );
};
